// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5574":"1ff01a93","6213":"fe40ec77","7190":"6ccaf9c2","9312":"53cae3be"}[chunkId] + ".chunk.css";
};